import { FC } from 'react';
import DocumentsItem from '../DocumentsItem';
import useIsMobile from 'src/hooks/useIsMobile';
import { IDriverFetch } from 'src/models/IDriver';
import './styles.scss';

interface IProps {
  driver: IDriverFetch;
}

const DriverItem: FC<IProps> = ({ driver }) => {
  const isMobile = useIsMobile();

  return (
    <div className='driver-docs'>
      <div className='driver-docs__container'>
        {isMobile && !driver.driver_license?.photos?.length && !driver.driver_license?.insurance ? (
          <div>missing</div>
        ) : (
          <>
            <DocumentsItem
              title='License'
              links={driver.driver_license?.photos as string[] | undefined}
            />
            <DocumentsItem
              title='Insurance'
              links={driver.driver_license?.insurance as string[] | undefined}
            />
          </>
        )}
      </div>
    </div>
  );
};

export default DriverItem;
